// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Specjalization_wrapper__1Xolm","image":"Specjalization_image__2k_AW","imageCad":"Specjalization_imageCad__1f9aP","text":"Specjalization_text__2yYk0"};